<template>
  <router-view/>
  <!-- <Maintanance></Maintanance> -->
</template>

<script>
import { defineComponent, computed, reactive } from 'vue'
import Maintanance from './pages/maintanance/Maintanance.vue';

export default defineComponent({
  components: { Maintanance },
});
</script>

<style lang="scss">
@import '@/sass/main.scss';

#app {
  /* font-family: 'Source Sans Pro', Avenir, Helvetica, Arial, sans-serif; */
  font-family: 'Lato-Light', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body {
  margin: 0;
  background: var(--va-background);
}
</style>
